<template>
    <div class="provider-stats">
        <div class="browser">
            <div class="browser-left">
                <checkbox class="check" label="Agrupar por proveedor" />
            </div>
            <div class="browser-right">
                <a-button @click="handlerCleanFilter">
                    <fa-icon :icon="['fas', 'broom-wide']" />
                </a-button>
                <a-button type="primary" @click="handlerFilter">
                    <fa-icon :icon="['far', 'magnifying-glass-plus']" class="mr-2" /> Nueva busqueda
                </a-button>
            </div>
        </div>
        <ul class="details">
            <li class="detail-card" v-for="(item, index) in details" :key="index">
                <fa-icon :icon="['fas', item.icon]" />
                <div class="stats">
                    <apexchart
                        :ref="item.ref"
                        type="area"
                        width="100%"
                        height="50px"
                        :options="detailsOptions"
                        :series="item.series"
                    />
                </div>
                <p>{{ item.title }}</p>
                <h2>{{ item.value }}€</h2>
            </li>
        </ul>
        <section class="sells">
            <div class="sells-header">
                <h1>Ventas Totales</h1>
                <ul v-if="false" class="periods">
                    <li>
                        <tag />
                    </li>
                </ul>
                <a-button type="primary" @click="handlerFilter">
                    <fa-icon :icon="['fas', 'square-plus']" class="mr-2" /> Añadir periodo
                </a-button>
            </div>
            <div class="sells-content">
                <apexchart type="line" width="100%" :height="600" :options="sellsOptions" :series="sellsSeries" />
            </div>
        </section>
    </div>
</template>

<script>
import Actions from './_actions'
import Variables from './_variables'
import Checkbox from '@/application/components/checkbox.vue'
import Tag from '@/application/components/tag.vue'
import Apexchart from 'vue-apexcharts'

export default {
    mixins: [Actions],
    components: { Checkbox, Tag, Apexchart },
    data() {
        return Variables()
    },
}
</script>

<style scoped lang="scss">
@import './styles.scss';
</style>
